import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

/**
 * AuthLink — a NavLink that gates clicks behind sign-in.
 *
 * If the user is signed in, behaves like a normal NavLink (navigates to `to`).
 * If not, intercepts the click and routes to /signin?next=<encoded to>, so
 * the sign-in page can return them to the intended page after auth.
 *
 *   <AuthLink to="/job-listings" className="nav-link">Need a Job?</AuthLink>
 */
const AuthLink = ({ to, children, className = '', activeClassName = 'active', onClick, ...rest }) => {
    const navigate = useNavigate();
    const isSignedIn = Boolean(localStorage.getItem('token'));

    const handleClick = (e) => {
        if (onClick) onClick(e);
        if (e.defaultPrevented) return;
        if (!isSignedIn) {
            e.preventDefault();
            const next = encodeURIComponent(to);
            navigate(`/signin?next=${next}`);
        }
    };

    return (
        <NavLink
            to={to}
            className={({ isActive }) =>
                `${className} ${isActive ? activeClassName : ''}`.trim()
            }
            onClick={handleClick}
            {...rest}
        >
            {children}
        </NavLink>
    );
};

export default AuthLink;
